export default __webpack_public_path__ + "static/media/card7.a757eba3.png";